module.exports = __webpack_public_path__ + "img/Frame 29.94ac666a.png";